import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const [status, setStatus] = useState("polling");
  const [record, setRecord] = useState(null);

  useEffect(() => {
    if (!sid) { setStatus("unknown"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        setRecord(data);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (tries++ < 20) setTimeout(poll, 2000);
        else setStatus("pending");
      } catch { setStatus("error"); }
    };
    poll();
  }, [sid]);

  return (
    <section className="max-w-2xl mx-auto px-6 py-32 text-center">
      <CheckCircle2 className="h-14 w-14 text-forest mx-auto mb-6" strokeWidth={1.5} />
      <h1 className="font-serif text-5xl">{status === "paid" ? "Thank you." : "Confirming your gift…"}</h1>
      <p className="text-ink-soft mt-4">
        {status === "paid" && `Your ${record?.fund?.replace("_"," ")} gift of $${record?.amount} has landed. It becomes soil, seed, and shelter.`}
        {status === "polling" && "This takes just a moment."}
        {status === "pending" && "Your payment is still processing. We'll email you when confirmed."}
        {status === "error" && "We couldn't confirm your payment. Please contact us."}
      </p>
      <Link to="/" data-testid="success-home-link" className="pill pill-primary mt-10 inline-flex">Return home</Link>
    </section>
  );
}
